import { render, staticRenderFns } from "./commonTitle.vue?vue&type=template&id=9dde64d6&scoped=true"
import script from "./commonTitle.vue?vue&type=script&lang=ts"
export * from "./commonTitle.vue?vue&type=script&lang=ts"
import style0 from "./commonTitle.vue?vue&type=style&index=0&id=9dde64d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dde64d6",
  null
  
)

export default component.exports